const designCntnt = (() => {
  if (document.querySelector("body#pageDesign") !== null) {



    let jsSecPin = document.querySelector('#jsSecPin');
    // let cntntWrap = secCntnt.querySelector('.js-cntnt-wrap');
    // let cntntArea1 = cntntWrap.querySelector('.cntnt-area.num-1');
    // let cntntArea2 = cntntWrap.querySelector('.cntnt-area.num-2');
    // let cntntArea3 = cntntWrap.querySelector('.cntnt-area.num-3');
    // let cntntArea4 = cntntWrap.querySelector('.cntnt-area.num-4');
    // let trgrWraps = secCntnt.querySelectorAll('.trgr-wrap');


    let pin = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: '#jsSecPin .js-img-wrap',
        endTrigger: '#jsSecPin',
        start: "0% 0%",
        end: "100% 100%",
        // onEnter: () => cntntArea1.classList.add('is-act'),
        // onLeave: () => console.log("onLeave"),
        // onEnterBack: () => console.log("onEnterBack"),
        // onLeaveBack: () => cntntArea1.classList.remove('is-act'),
        pin: true,
        pinSpacing: false,
        // markers: true,
      },
    })

    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsSecPin .js-cntnt-area.num2',
      start: "0% 50%",
      toggleClass: {
        targets: "#jsSecPin .js-img-area.num2",
        className: "is-act"
      },
      // markers: true,
    });
    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsSecPin .js-cntnt-area.num2',
      start: "0% 0%",
      toggleClass: {
        targets: "#jsSecPin .js-img-area.num2 .js-cover",
        className: "is-act"
      },
      // markers: true,
    });

    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsSecPin .js-cntnt-area.num3',
      start: "0% 0%",
      toggleClass: {
        targets: "#jsSecPin .js-img-area.num3",
        className: "is-act"
      },
      // markers: true,
    });

    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsSecPin .js-cntnt-area.num4',
      start: "0% 50%",
      toggleClass: {
        targets: "#jsSecPin .js-img-area.num4",
        className: "is-act"
      },
      // markers: true,
    });
    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsSecPin .js-cntnt-area.num4',
      start: "50% 50%",
      toggleClass: {
        targets: "#jsSecPin .js-img-area.num4 .js-cover",
        className: "is-act"
      },
      // markers: true,
    });

    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsSecPin .js-cntnt-area.num5',
      start: "0% 50%",
      toggleClass: {
        targets: "#jsSecPin .js-img-area.num5",
        className: "is-act"
      },
      // markers: true,
    });
    ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '#jsSecPin .js-cntnt-area.num5',
      start: "0% 0%",
      toggleClass: {
        targets: "#jsSecPin .js-img-area.num5 .js-cover",
        className: "is-act"
      },
      // markers: true,
    });



    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        pin.scrollTrigger.refresh()
      });
    });
    observer.observe(target);



  }
})()
export default designCntnt;